import './inviteEmployee.component.scss';
import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import lang from '../../../../assets/i18n/en.json';
import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { emailValidation } from '../../../../utils/Utils';
import { BasicPopup } from '../../../Common/basicPopup/BasicPopup';

export const InviteEmployee = (props) => {
  /**
   * DECLARING STATES AND USEEFFECT
   */
  let PAGE = lang.PAGE;

  const [userData, setUserData] = useState({
    emailId: '',
  });
  const [errors, setError] = useState({});

  // Reset the form data and errors when the modal is closed
  useEffect(() => {
    setError({
      email: false,
      emailError: '',
    });

    setUserData({
      emailId: props?.selectedRow.email ? props?.selectedRow.email : '',
    });
  }, [props?.selectedRow]);

  const [showBasicPopup, setShowBasicPopup] = useState(false);

  const onSubmit = async () => {
    try {
      let data = {
        emailId: userData.emailId,
      };
      if (data) {
        props.onInviteHide();
        setShowBasicPopup(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        show={props.showInvite}
        onHide={() => {
          props.onInviteHide();
        }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header
          className="modal-header px-8 pt-8 pb-4"
          closeButton
          style={{
            borderBottom: '#fff',
            margin: '0%',
            alignItems: 'flex-start',
          }}
        >
          <Modal.Title>
            <div className="fw-bolder"> Invite Employee</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          className="px-8 py-0 modal-body"
          style={{ borderBottom: '#fff', margin: '0%' }}
        >
          <p>
            An invite with app download link & unique code will be sent to the
            provided email. This code enables employee registeration.
          </p>

          <form className="form w-100 w-lg-450  h-100" autoComplete="off">
            {/* 
                       <!--begin::Form group--> */}
            <div className="fv-row my-4">
              <Form.Label>{PAGE.AUTH.SIGNUP.EMAIL.LABEL}</Form.Label>

              <Form.Control
                type="email"
                name="emailId"
                value={userData.emailId}
                className="form-control form-control-lg form-control-solid fs-6"
                onChange={(e) => {
                  setUserData((userData) => ({
                    ...userData,
                    emailId: e.target.value,
                  }));
                  emailValidation(e.target.value, errors, setError);
                }}
                placeholder={PAGE.AUTH.SIGNUP.EMAIL.PLACEHOLDER}
                isInvalid={errors.email}
              />
              <Form.Control.Feedback type="invalid" style={{ color: 'red' }}>
                {errors.emailError}
              </Form.Control.Feedback>
            </div>
            {/*
                         <!--end::Form group--> */}
          </form>
        </Modal.Body>
        <Modal.Footer
          className="pt-0 px-8 pb-8 modal-footer"
          style={{ borderTop: '#fff', margin: '0%' }}
        >
          <Button
            className="theme float-end"
            onClick={(e) => {
              e.preventDefault();
              onSubmit();
            }}
            disabled={!(userData.emailId && !errors.email)}
          >
            Sent Invite
          </Button>
        </Modal.Footer>
      </Modal>

      <BasicPopup
        show={showBasicPopup}
        onHide={() => setShowBasicPopup(false)}
        popupTitle="App Invite sent Successfully"
        popupSubTitle={'App Invite sent successfully'}
        otherButtonText={''}
      />
    </>
  );
};
